import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/default-profile.png'


const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "flex flex-wrap items-center gap-1 w-full filter-chips" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_4 = { class: "color-white text-sm" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "flex items-center gap-1"
}
const _hoisted_7 = { class: "color-white text-sm" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src", "onClick"]
const _hoisted_10 = {
  key: 1,
  src: _imports_0,
  width: "50",
  alt: "photo"
}
const _hoisted_11 = { class: "clm-act-cntn" }
const _hoisted_12 = ["onClick"]

import { computed, getCurrentInstance, onMounted, ref } from 'vue'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { Form, Field } from 'vee-validate'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import InputSwitch from 'primevue/inputswitch'
import OverlayPanel from 'primevue/overlaypanel'
import ProgressSpinner from 'primevue/progressspinner'
import moment from 'moment'
import EmptyState from '@/views/components/list/EmptyState.vue'
import Paginator from '@/views/components/paginator/Paginator.vue'
import ListActions from '@/views/components/list/ListActions.vue'
import HjpDefaultModal from '@/views/components/modal/ModalDefault.vue'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import CheckExistingDataDialog from './components/dialog/CheckExistingDataDialog.vue'
import SearchOptions from './components/panel/SearchOptions.vue'
import EmployeeHeaderTable from './components/panel/EmployeeHeaderTable.vue'
import FilterOptions from './components/panel/FilterOptions.vue'

const moduleStore = 'employee'
const employeeEndpoint = 'talent/v1/employees'
const positionEmployment = 'talent/v1/positions'
const regionEndpoint = 'talent/v1/regions'

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore()
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const dataSource = ref([]) as any
const isLoading = ref(false)
const emptyTable = ref('Data belum ada, silahkan tambah untuk mengisi data')
const headerTitle = ref('Master Karyawan')
const secondearyHeaderTitle = ref('Download')
const buttonTitle = ref('')
const searchPlaceholder = ref('Cari Disini...')
const showForm = ref(false)
const dataRow = ref(null) as any
const refOverlayAction = ref()
const op = ref()
const opf = ref()
const showConfirmDialog = ref(false)
const isShowSearchIdentificationNumberDialog = ref(false)
const positionFilterOptions = ref([])
const regionFilterOptions = ref([])
const selectedFilter = ref({
  positions: [] as any,
  regions: [] as any
})
const confirmDialogDelete = ref({
  title: 'Hapus Karyawan?',
  subTitle: 'Data karyawan tersebut akan dihapus dalam sistem. Yakin hapus data karyawan?',
  btnSubmitTitle: 'Hapus Karyawan',
})

const confirmDataExistDialog = ref({
  title: 'Karyawan Sudah Terdaftar!',
  subTitle: '',
  btnSubmitTitle: 'Hapus Karyawan',
  isHtml: true,
  image: require('@/assets/img/modal-confirmation/existing-data.svg')
})
const router = useRouter()
const filters = {
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  search: '',
  filterField: [],
  custom: [] as any
}

const selectedSearch = ref({ label: 'Nama', value: 'FullName', id: null })

const searchParamOptions = ref([

  // { label: 'NIK', value: 3 }
])

const onSort = (val: any) => {
  console.log('onSort', val)
}

const getAllData = async () => {
  store.dispatch('showLoading')
  console.log('filtersAll', filters)
  await apiUseCase.get(`${employeeEndpoint}${returnUrlPrams(filters)}`).then((response) => {
    const {
      error,
      result
    } = response
    if (!error) {
      console.log('result', result)
      dataSource.value = result.data
      filters.totalRecords = result.count
    }
  })
  store.dispatch('hideLoading')
}

const onSearch = (value: any) => {
  console.log('selectedSearch', selectedSearch.value)
  if (selectedSearch.value?.id) {
    filters.custom = [['documentSearch', '=', value === '' ? '' : `${selectedSearch.value?.label}:${value}`]]
  } else {
    filters.custom = [[selectedSearch.value.value, '=', value]]
  }
  filters.pageNumber = 1
  getAllData()
}

const onClickBtnAdd = () => {
  isShowSearchIdentificationNumberDialog.value = true
}

const addData = () => {
  // console.log('add')
  // showForm.value = true
  router.push({
    name: 'master-employee-form'
  })
}

const closeForm = () => {
  showForm.value = false
}

const setDataRowOnState = () => {
  // console.log('dataRow', dataRow.value)
  store.dispatch('storeRowDataTable', dataRow.value)
}

const reloadParentAct = () => {
  getAllData()
}

const onChangePage = (val: any) => {
  filters.pageNumber = val.page + 1
  getAllData()
}

const onDelete = () => {
  console.log('del')
  setDataRowOnState()
  showConfirmDialog.value = true
  console.log('showConfirmDialog', showConfirmDialog.value)
}

const hideDialogConfirmation = () => {
  showConfirmDialog.value = false
}

const onDeleteProcess = async () => {
  store.dispatch('showLoading')
  try {
    await apiUseCase.delete(employeeEndpoint, dataRow.value.id).then((response) => {
      const { error, result } = response
      if (!error) {
        hideDialogConfirmation()
        $toast.add({
          severity: 'success',
          detail: 'Data berhasil dihapus',
          group: 'bc',
          closable: false,
          life: 3000
        })
        getAllData()
      } else {
        hideDialogConfirmation()
        $toast.add({
          severity: 'error',
          detail: 'Data gagal dihapus',
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    console.log('error', error)
    hideDialogConfirmation()
  }
  store.dispatch('hideLoading')
}

const onEdit = () => {
  console.log('edit')
  setDataRowOnState()
  router.push({
    name: 'master-employee-form',
    params: {
      id: encryptDecriptMethods.encrypt(dataRow.value)
    }
  })
}

const showDropDown = (evt: any, item: any) => {
  dataRow.value = item
  console.log('dataRow', dataRow.value)
  refOverlayAction.value.toggle(evt)
}

const selectSearchOption = (evt: any, val: any) => {
  console.log('valSearch', val)
  selectedSearch.value = val
  console.log(selectedSearch.value)
  op.value.toggle(evt)
}

const showSearchFilterDropdown = (evt: any) => {
  op.value.toggle(evt)
}

const showDropDownFilterAct = (evt: any) => {
  opf.value.toggle(evt)
}

const applyFilterAct = (data: any) => {
  selectedFilter.value = {
    positions: [],
    regions: []
  }
  selectedFilter.value = store.getters['employee/getEmployeeFilter']
  console.log('selectedFilter', selectedFilter.value.positions)

  if (selectedFilter.value.positions.length > 0) {
    filters.custom = filters.custom.filter((d: any) => d[0] !== 'LatestEmployment.PositionIds')
    selectedFilter.value.positions.map((dataPosition: any) => filters.custom.push(['LatestEmployment.PositionIds', '=', dataPosition.id]))
  } else {
    filters.custom = filters.custom.filter((d: any) => d[0] !== 'LatestEmployment.PositionIds')
  }

  if (selectedFilter.value.regions.length > 0) {
    filters.custom = filters.custom.filter((d: any) => d[0] !== 'LatestEmployment.RegionIds')
    selectedFilter.value.regions.map((dataRegion: any) => filters.custom.push(['LatestEmployment.RegionIds', '=', dataRegion.id]))
  } else {
    filters.custom = filters.custom.filter((d: any) => d[0] !== 'LatestEmployment.RegionIds')
  }

  filters.pageNumber = 1

  getAllData()
}

const deselectFilterPosition = (data: any) => {
  selectedFilter.value.positions = selectedFilter.value.positions.filter((d: any) => d.id !== data.id)
  store.dispatch('employee/setEmployeeFilter', selectedFilter.value)

  filters.custom = filters.custom.filter((d: any) => d[0] !== 'LatestEmployment.PositionIds')
  selectedFilter.value.positions.map((dataPosition: any) => filters.custom.push(['LatestEmployment.PositionIds', '=', dataPosition.id]))

  filters.pageNumber = 1
  getAllData()
}

const deselectFilterRegion = (data: any) => {
  selectedFilter.value.regions = selectedFilter.value.regions.filter((d: any) => d.id !== data.id)
  store.dispatch('employee/setEmployeeFilter', selectedFilter.value)

  filters.custom = filters.custom.filter((d: any) => d[0] !== 'LatestEmployment.RegionIds')
  selectedFilter.value.regions.map((dataRegion: any) => filters.custom.push(['LatestEmployment.RegionIds', '=', dataRegion.id]))

  filters.pageNumber = 1
  getAllData()
}

const getDataPosition = async () => {
  const filter = {
    custom: [['pageSize', '=', '100']]
  }
  await apiUseCase.get(`${positionEmployment}${returnUrlPrams(filter)}`).then((response) => {
    const { error, result } = response
    if (!error) {
      positionFilterOptions.value = result.data
    }
    // console.log('resPosition', result)
  })
}

const getDataRegion = async () => {
  const filter = {
    custom: [['pageSize', '=', '100']]
  }
  await apiUseCase.get(`${regionEndpoint}${returnUrlPrams(filter)}`).then((response) => {
    const { error, result } = response
    if (!error) {
      regionFilterOptions.value = result.data
    }
  })
}

const changeIsActive = (val: any) => {
  console.log('click', val)
}

const toExistingDataDetail = (data: any) => {
  console.log('dataEdit', data)
  dataRow.value = data
  onEdit()
}

const hideSearchIdentificationNumberDialog = () => {
  isShowSearchIdentificationNumberDialog.value = false
}

const onClickSecondaryBtn = async () => {
  store.dispatch('showLoading')
  const payload = {}
  await apiUseCase.postBlob(`${employeeEndpoint}/export`, payload).then((response) => {
    const { error, result } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data berhasil didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
      const blob = result
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `master karyawan (${moment().format('DD MMMM YYYY')}).pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Data gagal didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const openProfileImage = (url: any) => {
  window.open(url, '_blank')
}

const hideFilterPanel = () => {
  opf.value.hide()
}

onMounted(() => {
  getAllData()
  getDataPosition()
  getDataRegion()
  console.log('selectedFilter', selectedFilter.value)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(EmployeeHeaderTable, {
            titleHeader: headerTitle.value,
            titleButton: buttonTitle.value,
            onRedirectAdd: onClickBtnAdd,
            placeholder: searchPlaceholder.value,
            onOnSearch: onSearch,
            showSearch: true,
            onShowDropDown: showSearchFilterDropdown,
            extraButton: true,
            titleExtraButton: secondearyHeaderTitle.value,
            onRedirectAddExtraButton: onClickSecondaryBtn,
            selectedSearchParam: selectedSearch.value,
            onShowDropDownFilter: showDropDownFilterAct
          }, null, 8, ["titleHeader", "titleButton", "placeholder", "titleExtraButton", "selectedSearchParam"])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", {
          style: _normalizeStyle((selectedFilter.value?.positions) || (selectedFilter.value?.regions) ? 'display: inline' : 'dispaly: none'),
          class: "mb-3 flex items-center gap-3 w-full"
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-100px" }, _toDisplayString('Filter Aktif'), -1)),
          _createElementVNode("div", _hoisted_2, [
            (selectedFilter.value.positions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFilter.value.positions, (dataPositions) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: dataPositions.id,
                      class: "background-green-1 rounded-xl px-3 py-1 flex items-center gap-4"
                    }, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(dataPositions.name), 1),
                      _createElementVNode("i", {
                        class: "pi pi-times cursor-pointer text-sm color-white ml-2",
                        onClick: ($event: any) => (deselectFilterPosition(dataPositions))
                      }, null, 8, _hoisted_5)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (selectedFilter.value.regions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFilter.value.regions, (dataRegions) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: dataRegions.id,
                      class: "background-green-1 rounded-xl px-3 py-1"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createTextVNode(_toDisplayString(dataRegions.name) + " ", 1),
                        _createElementVNode("i", {
                          class: "pi pi-times cursor-pointer text-sm color-white ml-2",
                          onClick: ($event: any) => (deselectFilterRegion(dataRegions))
                        }, null, 8, _hoisted_8)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4),
        _createVNode(_unref(DataTable), {
          id: "hjp-data-table",
          value: dataSource.value,
          paginator: false,
          loading: isLoading.value,
          class: "table-og hjp-data-table",
          responsiveLayout: "scroll",
          onSort: onSort
        }, {
          empty: _withCtx(() => [
            _createVNode(EmptyState, { textNoData: emptyTable.value }, null, 8, ["textNoData"])
          ]),
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), { header: "Foto" }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: slotProps.data.imageUrl,
                      alt: "photo",
                      width: "50",
                      class: "rounded-lg cursor-pointer",
                      onClick: ($event: any) => (openProfileImage(slotProps.data.imageUrl))
                    }, null, 8, _hoisted_9))
                  : (_openBlock(), _createElementBlock("img", _hoisted_10))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Nama Lengkap" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.fullName), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Kode" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.oldPersonnelNumber), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Divisi" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(!!slotProps.data.latestEmployment == false ? "-" : slotProps.data.latestEmployment.positionName), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Wilayah" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(!!slotProps.data.latestEmployment == false ? "-" : slotProps.data.latestEmployment.regionName), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Tanggal Masuk" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_unref(moment)(slotProps.data.joinDate).format('DD-MM-YYYY')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Status" }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.latestEmployment)
                  ? (_openBlock(), _createBlock(_unref(InputSwitch), {
                      key: 0,
                      class: "input-success",
                      modelValue: slotProps.data.latestEmployment.isActive,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.latestEmployment.isActive) = $event),
                      disabled: true
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              class: "colom-action mx-auto",
              header: ""
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "px-4 py-2 flex items-center cursor-pointer rounded-lg",
                    onClick: ($event: any) => (showDropDown($event, slotProps.data))
                  }, _cache[1] || (_cache[1] = [
                    _createElementVNode("i", {
                      class: "pi pi-ellipsis-h",
                      style: {"font-size":"1rem"}
                    }, null, -1)
                  ]), 8, _hoisted_12)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ]),
      footer: _withCtx(() => [
        (filters.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: filters.pageSize,
              totalRecords: filters.totalRecords,
              onOnPage: onChangePage
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayAction",
      ref: refOverlayAction
    }, {
      default: _withCtx(() => [
        _createVNode(ListActions, {
          edit: true,
          del: true,
          showDetail: false,
          editTitle: 'Edit',
          delTitle: 'Hapus',
          showDetailTitle: 'Detail',
          onDel: onDelete,
          onEdit: onEdit
        })
      ]),
      _: 1
    }, 512),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "op",
      ref: op
    }, {
      default: _withCtx(() => [
        _createVNode(SearchOptions, {
          selected: selectedSearch.value,
          onSelectSearchOption: selectSearchOption
        }, null, 8, ["selected"])
      ]),
      _: 1
    }, 512),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "opf",
      ref: opf
    }, {
      default: _withCtx(() => [
        _createVNode(FilterOptions, {
          dataPositionList: positionFilterOptions.value,
          dataRegionList: regionFilterOptions.value,
          onHidePanel: hideFilterPanel,
          onOnSubmit: applyFilterAct
        }, null, 8, ["dataPositionList", "dataRegionList"])
      ]),
      _: 1
    }, 512),
    _createVNode(HjpCofirmModal, {
      show: showConfirmDialog.value,
      title: confirmDialogDelete.value?.title,
      subTitle: confirmDialogDelete.value?.subTitle,
      btnSubmitTitle: confirmDialogDelete.value?.btnSubmitTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: onDeleteProcess
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle"]),
    _createVNode(HjpDefaultModal, {
      show: isShowSearchIdentificationNumberDialog.value,
      onHideDialog: hideSearchIdentificationNumberDialog
    }, {
      content: _withCtx(() => [
        _createVNode(CheckExistingDataDialog, {
          onOpenFormCreate: addData,
          onOpenFormEdit: toExistingDataDetail,
          onHideDialog: hideSearchIdentificationNumberDialog
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})